import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_API_URL;
axios.defaults.baseURL = BASE_URL;

export default axios;
